import { configureStore } from "@reduxjs/toolkit";
import cartReducer from "./state.js"; // Assure-toi du bon chemin d'import
import langReducer from "./langueslice.js";
export const store = configureStore({
  reducer: {
    panier: cartReducer, // Ajout du reducer du panier
    langue: langReducer,
  },
});
